module.exports = __webpack_public_path__ + "static/media/2020-01-21 best-of-both-worlds.f0b86212.md";